import produce from 'immer';
import { initialRootState } from '../initialRootState';
import {
  EPaymentHistoriesActionType,
  TPaymentHistoriesAction,
} from './actions';
import { IHistoryEntry } from './types';

export interface IPaymentHistoriesState {
  entries: IHistoryEntry[];
}

export const paymentHistoriesReducer = (
  currentState: IPaymentHistoriesState = initialRootState.paymentHistories,
  action: TPaymentHistoriesAction
): IPaymentHistoriesState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EPaymentHistoriesActionType.GET_SUCCESS:
        draft.entries = action.payload.entries;
        break;
    }
  });
